import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, testid }) => (
  <div className="flex items-center gap-3 mb-5" data-testid={testid}>
    <span className="h-px w-8 bg-[var(--gold)]" />
    <span className="text-[11px] uppercase tracking-[0.3em] text-[var(--ink-3)]">{children}</span>
  </div>
);
